<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.title-btn {
  cursor:pointer;
  color: #FFFFFF;
  position: absolute;
  right: 0;
  top: -15px;
  height: 34px;
  line-height: 34px;
  background: linear-gradient( 123deg, #6FBFFA 0%, #3C8BF2 100%);
  border-radius: 12px 28px 0 12px;
  padding: 0 2rem 0 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue